import { organizationAdmins } from 'locales/ja/organization_admins';
import type { PageType } from 'types/page_type';

export const passwordResetRequestPage: Readonly<PageType> = {
  path: '/password/reset_request',
  title: `${organizationAdmins.resourceName} パスワードリセットメール送信`,
  description: `${organizationAdmins.resourceName}パスワードリセットメールの送信`,
};
